import * as React from 'react';

import { IPriceRangeModel } from '../reducers/filter-reducers';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';

import PriceRange from '../../common/filters/price-range';

interface IPriceRangeProps {
    onPriceRangeClear: (minPrice: number, maxPrice: number) => any;
    onSelectMinPrice: (number) => any;
    onSelectMaxPrice: (number) => any;
    lowerRangeLimit: number;
    upperRangeLimit: number;
    rangeMinSpread: number;
    startingMinPrice: number;
    startingMaxPrice: number;

    currencyFormat: string;
    clearButton: string;
    filterPriceRangeTitle: string;
    filterPriceRangeMessage: string
    filterPriceRangeMin: string;
    filterPriceRangeMax: string;

    showComponent: boolean;
}

interface IPriceRangeState {
}

class PriceRangeFilter extends React.PureComponent<IPriceRangeProps, IPriceRangeState>{
    render() {
        return (
            this.props.showComponent ?
                <form className="filters-section">
                    <PriceRange
                        {...this.props}
                        onPriceRangeClear={this.props.onPriceRangeClear}
                        onSelectMaxPrice={this.props.onSelectMaxPrice}
                        onSelectMinPrice={this.props.onSelectMinPrice}
                        startingMinPrice={this.props.startingMinPrice}
                        startingMaxPrice={this.props.startingMaxPrice}
                        showClearButton={true}
                        showTitle={true}
                    />
                </form>
                : null)
    }
}

export default PriceRangeFilter;